import { mediaQueryLarge } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    this.#restoreLayout();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#changeLayout(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #changeLayout = (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    this.#setLayout(value);
    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
    try { sessionStorage.setItem(`product-grid-view-${viewport}`, value); } catch {}
    this.dispatchEvent(new CustomEvent('dm:grid-layout', { bubbles: true }));
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #restoreLayout() {
    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
    let value = viewport === 'mobile' && this.refs.grid?.classList.contains('product-grid-mobile--large') ? 'mobile-single' : 'default';
    try { value = sessionStorage.getItem(`product-grid-view-${viewport}`) || value; } catch {}
    if (!(viewport === 'desktop' ? ['default', 'zoom-out'] : ['default', 'mobile-single']).includes(value)) value = 'default';
    this.#setLayout(value);
    this.querySelectorAll(`input[name="${viewport === 'desktop' ? 'grid' : 'grid-mobile'}"]`).forEach((input) => {
      input.checked = input.value === value;
    });
  }

  updatedCallback() {
    super.updatedCallback();
    this.#restoreLayout();
  }

  #handleMediaQueryChange = () => this.#restoreLayout();
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
